import React from 'react';
import Anonymous from '../../../resources/icon/annonymous.jpg'
import Doc from '../../../resources/icon/documnet-icon.png'
import Asset from '../../../resources/icon/assetTotal.png'
import {XCircleIcon} from "@heroicons/react/24/solid";
import {useNavigate} from "react-router-dom";
import {isMobile} from "../../commonmethod/CommonMethod";
import link from "../../../resources/icon/link.png"
import UserSelectionChips from "../../selection/UserSelectionChips";

function SimmsArrayContainer({data, onChange, entity, readonly, url, style}) {

    const navigate = useNavigate();

    if (entity === 'userAccount') {
        return (
            <UserSelectionChips
                data={data}
                onRemove={onChange}
                readonly={readonly}
                style={style}
            />
        );
    }
    function moveHandler(id){
        navigate(`${url}/`+id);
    }

    const getImageSrc = (entity) => {
        switch (entity) {
            case 'userAccount':
                return Anonymous
            case 'asset':
                return Asset
            case 'contract':
                return Doc
        }
    };
    const imgSrc = getImageSrc(entity);
    return (
        <div style={style}>
            { data && data?.length >0 &&  data.map((e, index) => (
                <div key={index} className={`flex items-center h-[30px] line-h-30 bg-${index % 2 === 0 ? 'even' : 'odd'}`}>
                    <div><img src={imgSrc} className={`${entity == 'asset' ? 'w-[15px] mt-0' : 'w-[24px]'} m-[3px] mr-3 print-hidden`}/></div>
                    <div className={`${isMobile ? "w-[130px]" : "w-[180px]"} truncate`}>{e.name ?? e.assetName}</div>
                    <div className={`${isMobile ? "ml-auto text-right w-[50px]" : "w-[100px]"} truncate`}>{entity==='userAccount' ? e.department?.name : entity==='asset' ? e.group?.name : ''}</div>
                    {!readonly && <div onClick={()=>onChange(e)}>
                        {/*<img src={Cancel} className={`w-[24px] m-[3px]`} />*/}
                        <XCircleIcon
                            className={'w-5 h-5 hover:text-[#bd1111] cursor-pointer'} title={"삭제"}

                        />
                    </div>}
                    {
                        url && !e.isRemoved &&
                        <span className={"cursor-pointer inline-flex justify-between gap-2 items-center px-2.5 py-1.5 text-xs transition-colors"}
                              onClick={() => moveHandler(e.id)}>
                                            <img width="25" height="25" src={link} alt="link" className={"print-hidden"}/>
                                        </span>
                    }
                </div>
            ))}
        </div>
    );
}

export default SimmsArrayContainer;